/* @ngInject */
const displayCtrl = (
  $scope,
  $$setting,
  $timeout,
  authService,
  toaster,
  storageHandler
) => {
  $scope.options = $$setting.data.general

  $timeout(function () {
    $scope.$broadcast('rzSliderForceRender')
  })

  $scope.clearLocalStorage = () => {
    storageHandler.clear()
    toaster.message(`L'historique à bien été remis à zéro.`)
  }

  $scope.saveSettings = async (_options) => {
    const checkboxs = _options.checkboxs
    const inputs = _options.inputs
    const sliders = _options.sliders

    const data = {
      userId: authService.getUid(),
    }

    for (const checkboxName in checkboxs) {
      if (checkboxs.hasOwnProperty(checkboxName)) {
        const checkbox = checkboxs[checkboxName]
        data[checkboxName] = checkbox.model
      }
    }

    for (const inputName in inputs) {
      if (inputs.hasOwnProperty(inputName)) {
        const input = inputs[inputName]
        data[inputName] = input.model
      }
    }

    for (const sliderName in sliders) {
      if (sliders.hasOwnProperty(sliderName)) {
        const slider = sliders[sliderName]
        data[sliderName] = slider.model
      }
    }

    try {
      const message = await $$setting.requests.saveGeneral(data)
      toaster.message(message)
    } catch (error) {
      toaster.error(error)
    }
  }
}

export default displayCtrl



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/setting/general/general.controller.js